import { apiAxios } from "../../apiConfig";

export const getEvents = async () => {
  try {
    const response = await apiAxios.get("/events/admin/all");

    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};

export const getEventRsvps = async (eventId) => {
  try {
    const response = await apiAxios.get(`/events/${eventId}/rsvps`);

    return response.data;
  } catch (error) {
    console.error("Error fetching event RSVPs:", error);
    throw error;
  }
};

export const createEvent = async (payload) => {
  try {
    const response = await apiAxios.post("/events", payload);

    return response.data;
  } catch (error) {
    console.error("Error creating event:", error);
    throw error;
  }
};

export const updateEvent = async (eventId, payload) => {
  try {
    const response = await apiAxios.put(`/events/${eventId}`, payload);

    return response.data;
  } catch (error) {
    console.error("Error updating event:", error);
    throw error;
  }
};

export const deleteEvent = async (eventId) => {
  try {
    const response = await apiAxios.delete(`/events/${eventId}`);

    return response.data;
  } catch (error) {
    console.error("Error deleting event:", error);
    throw error;
  }
};
